import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_TOKEN_INVALID',
    statusCode: 401,
    message: {
        en: 'Invalid Token',
    },
} as CustomErrorType;